module.exports = __webpack_public_path__ + "img/x.b1bd582d.svg";